const tech_img = require('../../assets/img/tutorials/cabalgata/tech.png');
const secondary_tech_img = require('../../assets/img/tutorials/cabalgata/secondary-tech.png');
const func_img = require('../../assets/img/tutorials/cabalgata/func.png');
const secondary_func_img = require('../../assets/img/tutorials/cabalgata/secondary-func.png');

export const CabalgataSteps = [
    {
        name: 'Cabalgata',
        title: 'Descripción funcional',
        description: <span>
            <p>El gemelo digital constituye una herramienta de <b>gestión, simulación y análisis que incorpora datos en tiempo real de la afluencia de personas y de posicionamiento de la propia cabalgata y dispositivos de emergencia y/o seguridad</b>.
            </p>
            <p>El modelo usa información recogida por sensores estratégicamente ubicados a lo largo de la ruta de la cabalgata, a través de los que se recopilan datos del flujo de personas, permitiendo monitorizar y gestionar la aglomeración de personas en tiempo real.
            </p>
            <p>Posibilita asegurar la seguridad y bienestar de los asistentes durante la presente edición a través de una gestión eficaz del espacio y del evento, y mejorar la planificación de futuras ediciones de la cabalgata, ajustando los recursos necesarios y mejorando la experiencia general, en base a la información del desarrollo de ediciones previas, o a simulación.
            </p>
        </span>,
        secondarydescription: <span>
            <p>Área de Gobierno de Cultura, Turismo y Deporte</p>
            <p>Área de Gobierno de Vicealcaldía, Portavoz, Seguridad  y Emergencias</p>
        </span>,
        mainimage: <img src={func_img} alt="main_func" />,
        secondaryimage: <img src={secondary_func_img} alt="sec_func" />,
    },
    {
        name: 'Cabalgata',
        title: 'Descripción técnica',
        description: <div>
            <span>
                Integraciones técnicas
                <ul>
                    <li><b>Integración de Cartografía 2D y 3D</b>: Permite una representación detallada del espacio urbano y la interpretación de patrones geoespaciales.</li>
                    <li><b>Incorporación de Datos de IoT</b>: Para el monitoreo y análisis en tiempo real del movimiento y comportamiento de las multitudes.</li>
                    <li>Aplicación de algoritmos de <b>simulación avanzada</b> para predecir y visualizar la afluencia de personas en eventos públicos, optimizando la planificación y la seguridad.
</li>
                </ul>
            </span>
            <span>
                Origen de Datos
                <ul>
                    <li><b>Datos sintetizados</b> a partir de sensores especializados en medir la afluencia y movimientos de personas, proporcionando información clave para la toma de decisiones estratégicas.</li>
                    <li><b>Programación y rutas de eventos masivos como la Cabalgata</b>, integrando horarios y recorridos para una gestión y comunicación efectiva con la ciudadanía.</li>
                </ul>
            </span>

        </div>,
        mainimage: <img src={tech_img} alt="main_tech" />,
        secondaryimage: <img src={secondary_tech_img} alt="sec_tech" />,
    }
];